import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { ROUTE } from '@lib/core/const';
import { HttpStatusCode } from '@lib/core/enum';
import { TokenService } from '@lib/core/token';
import { catchError, EMPTY, Observable, of, switchMap, take, throwError } from 'rxjs';

import { User } from '../model';
import { UserCardRepository } from '../user-card.repository';

export const UserResolve: ResolveFn<User> = (route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<User> => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const userRepository = inject(UserCardRepository);
  const userId = route.params.userId;

  return userId
    ? userRepository.getUser(userId).pipe(
      catchError(({ code }) => {
        code === HttpStatusCode.UNAUTHORIZED
          ? tokenService.removeCredentials(true, routerState.url)
          : router.navigate([ROUTE.NOT_FOUND]);

        return of(null as User);
      })
    )
    : tokenService.token$.pipe(
      take(1),
      switchMap((token) => (null !== token
        ? userRepository.getUser(token.user.uuid)
        : throwError(() => 'token is not defined'))
      ),
      catchError(() => {
        tokenService.removeCredentials();

        return EMPTY;
      })
    );
};
